import { Trans } from '@/components'
import { Instance } from '@/models/instance'
import { formatRamMB } from '@/utils/formatter'

interface TeamInstanceHardwareProps {
  instance: Instance
}

export function TeamInstanceHardware({ instance }: TeamInstanceHardwareProps) {
  const { hardware } = instance

  return (
    <div className="flex flex-col gap-6">
      {/* GPU Section (if exists) */}
      {hardware.gpu.gpuIds.length > 0 && (
        <div>
          <div className="flex gap-2 items-center px-0 py-2 mb-4">
            <div className="bg-btn-secondary h-5 w-1" />
            <p className="h6 text-primary">
              <Trans i18nKey="instance.detail.hardware.gpuInfo">GPU Information</Trans>
            </p>
          </div>

          <div className="bg-panel-gray-100 p-4 rounded-lg">
            <div className="grid grid-cols-3 gap-4">
              {/* GPU Model */}
              <div className="flex flex-col gap-1">
                <div className="t-xs text-secondary">
                  <Trans i18nKey="instance.detail.hardware.gpu">GPU Model</Trans>
                </div>
                <div className="t-sb text-primary">{hardware.gpu.gpuName}</div>
              </div>

              {/* GPUs Count */}
              <div className="flex flex-col gap-1">
                <div className="t-xs text-secondary">
                  <Trans i18nKey="instance.detail.hardware.gpus">GPUs</Trans>
                </div>
                <div className="t-sb text-primary">{hardware.gpu.gpuIds.length}</div>
              </div>

              {/* GPU RAM */}
              <div className="flex flex-col gap-1">
                <div className="t-xs text-secondary">
                  <Trans i18nKey="instance.detail.hardware.gpuRam">GPU RAM</Trans>
                </div>
                <div className="t-sb text-primary">{formatRamMB(hardware.gpu.gpuRamMB)}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CPU/RAM/Storage Section */}
      <div>
        <div className="flex gap-2 items-center px-0 py-2 mb-4">
          <div className="bg-btn-secondary h-5 w-1" />
          <p className="h6 text-primary">
            <Trans i18nKey="instance.detail.hardware.computeInfo">Hardware</Trans>
          </p>
        </div>

        <div className="bg-panel-gray-100 p-4 rounded-lg">
          <div className="grid grid-cols-4 gap-4">
            {/* CPU Model */}
            <div className="flex flex-col gap-1">
              <div className="t-xs text-secondary">
                <Trans i18nKey="instance.detail.hardware.cpu">CPU Model</Trans>
              </div>
              <div className="t-sb text-primary">{hardware.machine.cpuName}</div>
            </div>

            {/* vCPUs */}
            <div className="flex flex-col gap-1">
              <div className="t-xs text-secondary">
                <Trans i18nKey="instance.detail.hardware.vCpus">vCPUs</Trans>
              </div>
              <div className="t-sb text-primary">{hardware.machine.cpuIds.length}</div>
            </div>

            {/* RAM */}
            <div className="flex flex-col gap-1">
              <div className="t-xs text-secondary">
                <Trans i18nKey="instance.detail.hardware.ram">RAM</Trans>
              </div>
              <div className="t-sb text-primary">{formatRamMB(hardware.machine.ramMB)}</div>
            </div>

            {/* Storage */}
            <div className="flex flex-col gap-1">
              <div className="t-xs text-secondary">
                <Trans i18nKey="instance.detail.hardware.storage">Storage</Trans>
              </div>
              <div className="t-sb text-primary">{hardware.machine.diskGB} GB</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
